import React from "react";
import styled from "styled-components";

const StyledLayout = styled.div`
  display: table-row;
  height: 100%;
`;

const Layout = ({ children }) => <StyledLayout>{children}</StyledLayout>;

export default Layout;
